"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : NAV : VERTICAL STACK : STYLES --------------- ++++++++++ */


var _default = {
  verticalstacknav: {
    border: "1px solid rgb(239, 239, 239)",
    '& .navitem': {
      borderBottom: "1px solid rgb(239, 239, 239)",
      width: '100%',
      height: (0, _index.pxToEm)(54),
      '& .link': {
        fontSize: (0, _index.pxToEm)(14),
        width: '100%',
        height: '100%',
        padding: (0, _index.replacePXinStringWithEM)("0 20px"),
        '&.isActive-true': {
          background: "rgb(250, 251, 252)",
          fontWeight: '500'
        }
      },
      '&.selected-true': {
        // pointerEvents: 'none',
        cursor: 'default',
        '& .link': {
          fontWeight: 'bolder',
          background: "rgb(250, 251, 252)"
        }
      },
      '&.selected-false': {
        '& .link': {
          '&:hover': {
            background: (0, _index.convertHexToRGB)(_index.theme.color.secondary.medium.swatch, 10)
          }
        }
      },
      '&:last-child': {
        borderBottom: '0'
      }
    }
  }
};
exports.default = _default;